module.exports = __webpack_public_path__ + "static/img/qnset2.cd14da3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/qnset2.png
// module id = 356
// module chunks = 0